import { Dispatch, SetStateAction } from "react";
import { OrdersListElementType, OrdersListIdProgressType, OrdersSearchParamType } from "../interface";
import { SubmitHandler, useForm } from "react-hook-form";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import { useManualSyncAll } from "../../../../manage/items/hooks/useManualSyncAll";
import { useModal } from "../../../../../hooks";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    searchParam: OrdersSearchParamType
    setSearchParam: Dispatch<SetStateAction<OrdersSearchParamType>>
    setCheckedElements: Dispatch<SetStateAction<OrdersListElementType[]>>
}

export default function Filter({ searchParam, setSearchParam, setCheckedElements }: PropsType) {
    const { goToNavigation } = useGoToNavigation();
    const { handleModal } = useModal();

    const { mutate: mutateManualSyncAll } = useManualSyncAll()
    const { register, handleSubmit, setValue, watch } = useForm({
        defaultValues: searchParam,
    });

    const btnSync = () => {
        handleModal({
            isOpen: true,
            contents: "시간이 다소 소요될 수 있습니다.\n동기화 하시겠습니까?",
            type: "confirm",
            callback: () => mutateManualSyncAll()
        })
    }

    const onSubmit: SubmitHandler<OrdersSearchParamType> = (submitData) => {
        goToNavigation(`order/orders/list?pageNo=1`, {}, false);
        setCheckedElements([])
        setSearchParam({ ...submitData, pageNo: 1 });
    };

    return (
        <div className="fiter_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">수주/출하 검색</h3>
                <div className="filter_toolbar"></div>
            </div>
            <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="col-6">
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">상태</label>
                        <select className="form-select"
                            value={watch("progress")}
                            {...register("progress")}
                        >
                            <option value={"0"}>전체</option>
                            <option value={"100000000"}>수주</option>
                            <option value={"100000001"}>출하요청</option>
                            <option value={"100000002"}>출하</option>
                            <option value={"100000003"}>이관</option>
                        </select>
                    </div>
                </div>
                <div className="col-6">
                    <div className="frm_row">
                        <label htmlFor="" className="form-label frm_label">수주일자</label>
                        <div className="frm_field input_date">
                            <input type="date" className="form-control"
                                max="9999-12-31"
                                {...register("fromDate")} />
                            <span className="txt_range">~</span>
                            <input type="date" className="form-control me-0"
                                max="9999-12-31"
                                {...register("toDate")} />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                            <AuthorityChecker authorityNames={['shipmentWriteYn']}>
                                <button className="btn btn-primary" onClick={e => {
                                    e.stopPropagation()
                                    btnSync()
                                }}>
                                    CRM 동기화
                                </button>
                            </AuthorityChecker>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
